import React from 'react';
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import './BannerWithBreadcrumb.css';

const BannerWithBreadcrumb = ({ title, breadcrumbItems }) => (
  <div className="inner-banner">
    <Container>
      <Row className="align-items-center">
        <Col>
          <h1 className="banner-title">{title}</h1>
          <Breadcrumb>
            {breadcrumbItems.map((item, idx) =>
              item.link ? (
                <Breadcrumb.Item key={idx} href={item.link}>
                  {item.label}
                </Breadcrumb.Item>
              ) : (
                <Breadcrumb.Item key={idx} active>
                  {item.label}
                </Breadcrumb.Item>
              )
            )}
          </Breadcrumb>
        </Col>
      </Row>
    </Container>
  </div>
);

export default BannerWithBreadcrumb; 